<script>
  import { onMount } from 'svelte';
  import { format } from 'svelte-i18n';
  import { Input } from '@sveltestrap/sveltestrap';

  import { GroupsService } from '@client/services/groups';

  import { sanitizeInputValue } from '@client/utils/sanitize';

  export let group = {};
  export let invalid = false;
  export let disabled = false;
  export let optional = false;

  let groups = [];
  let feedback = '';
  let value = group.groupname;

  const validateGroupName = () => {
    if (value === '' && !optional) {
      feedback = $format('label.VALIDATION_ERROR_NO_GROUP_NAME');
    } else if (value !== '' && groups.includes(value) && value !== group.groupname) {
      feedback = $format('label.VALIDATION_ERROR_GROUP_NAME_IN_USE');
    } else {
      feedback = '';
      if (value !== '') {
        group.groupname = value = sanitizeInputValue(value);
      } else {
        group.groupname = '';
      }
    }
  };

  onMount(async () => {
    const response = await GroupsService.getAll();
    groups = response.map(({ groupname }) => groupname !== group.groupname && groupname).filter(Boolean);
  });

  $: invalid = feedback !== '';
</script>

<span class="rulename">
  <Input
    type="text"
    bind:value
    on:keyup={validateGroupName}
    bind:feedback
    bind:invalid
    {disabled}
    placeholder={$format('label.PLACEHOLDER.GROUP_NAME')}
  />
</span>

<style lang="scss" src="./group-name.scss"></style>
